import { DropDown, Link } from "../component/element";
import { FormItemValidation } from "../component/object";
import { StrapiAsset } from "../StrapiType";

export enum FormItemType {
  Text = "Text",
  Number = "Number",
  Dropdown = "Dropdown",
  TextArea = "TextArea",
  PhoneNumber = "PhoneNumber",
  DatePicker = "DatePicker",
  Checkbox = "Checkbox",
}

export enum FormItemDefinedPropertyType {
  FirstName = "firstName",
  LastName = "lastName",
  Email = "email",
  Phone = "phoneNumber",
  Description = "description",
  AgreeToSMS = "agreeToSMS",
  WhatsApp = "whatsApp",
}

export type FormItem = {
  id: string;
  name: string;
  label: string;
  placeholder: string;
  type: FormItemType;
  jsonPropertyName: string;
  definedProperty?: FormItemDefinedPropertyType;
  crmPropertyName?: string;
  textAreaLines?: number;
  dropdownOptions?: DropDown[];
  startIcon?: StrapiAsset;
  validation?: FormItemValidation;
  extendedLabel?: string;
  extendedLabelLinks?: Array<Link>;
  xs?: number;
  md?: number;
  defaultValue?: string;
};
